import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { LocalisationService } from 'src/app/localisation.service';
import { Sport } from 'src/app/sport.model';
import { SPORTS } from 'src/app/sports';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-sport-icon',
  templateUrl: './sport-icon.component.html',
  styleUrls: ['./sport-icon.component.scss']
})
export class SportIconComponent implements OnChanges {
  @Input() code: string;
  @Input() colour: string;
  sport: Sport;
  environment = environment;
  constructor(
    private localisationService: LocalisationService,
  ) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (Object.keys(changes).includes("code")) {
      const sportCodeChange = changes["code"];
      if (this.localisationService.sportPrioritySort(SPORTS).some(s => s.code === sportCodeChange.currentValue)) {
        this.sport = SPORTS.find(s => s.code === sportCodeChange.currentValue);
      } else {
        console.warn(`SportIconComponent constructor failed - sport code ${sportCodeChange.currentValue} not found`);
      }
    }
  }

}
